import { render, staticRenderFns } from "./Unsynced.vue?vue&type=template&id=98353db0&"
import script from "./Unsynced.vue?vue&type=script&lang=js&"
export * from "./Unsynced.vue?vue&type=script&lang=js&"
import style0 from "./Unsynced.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports